import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=9bd03316&scoped=true"
import script from "./edit-product.vue?vue&type=script&lang=js"
export * from "./edit-product.vue?vue&type=script&lang=js"
import style0 from "./edit-product.vue?vue&type=style&index=0&id=9bd03316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd03316",
  null
  
)

export default component.exports